import * as fromActions from './corporate-dashboard.actions';
import {
  CorporateDashboardQuery,
  CorporateAppointmentsResponse,
  DashboardCountsData
} from '../../shared/services/corporate-appointment-dashboard.service';

export interface CorporateDashboardState {
  query: CorporateDashboardQuery;
  appointments: CorporateAppointmentsResponse;
  dashboardCounts: DashboardCountsData | null;
  loading: boolean;
  loaded: boolean;
  countsLoading: boolean;
  countsLoaded: boolean;
  error: string;
}

export const initialState: CorporateDashboardState = {
  query: {
    department: 'all',
    category: 'all',
    type: [],
    appointmentBookingSource: '',
    vehicle: '',
    dealer: '',
    todayRecords: false,
    rosReceived: false,
    pageNo: 1,
    size: 20
  },
  appointments: {
    items: [],
    totalCount: 0
  },
  dashboardCounts: null,
  loading: false,
  loaded: false,
  countsLoading: false,
  countsLoaded: false,
  error: ''
};

export function corporateDashboardReducer(
  state: CorporateDashboardState = initialState,
  action: fromActions.CorporateDashboardActions): CorporateDashboardState {
  switch (action.type) {
    case fromActions.CorporateDashboardActionTypes.SET_QUERY: {
      const payload = action instanceof fromActions.SetCorporateDashboardQuery ? action.payload : undefined;
      return {
        ...state,
        query: payload?.query || state.query,
        error: ''
      };
    }

    case fromActions.CorporateDashboardActionTypes.LOAD_APPOINTMENTS: {
      return {
        ...state,
        appointments: {
          items: [],
          totalCount: 0
        },
        loading: true,
        loaded: false,
        error: ''
      };
    }

    case fromActions.CorporateDashboardActionTypes.LOAD_APPOINTMENTS_SUCCESS: {
      const payload = action instanceof fromActions.LoadCorporateDashboardAppointmentsSuccess ? action.payload : undefined;
      return {
        ...state,
        appointments: payload?.appointments || state.appointments,
        loading: false,
        loaded: true,
        error: ''
      };
    }

    case fromActions.CorporateDashboardActionTypes.LOAD_APPOINTMENTS_FAILURE: {
      const payload = action instanceof fromActions.LoadCorporateDashboardAppointmentsFailure ? action.payload : undefined;
      return {
        ...state,
        loading: false,
        loaded: false,
        error: payload?.error || ''
      };
    }

    case fromActions.CorporateDashboardActionTypes.LOAD_DASHBOARD_COUNTS: {
      return {
        ...state,
        countsLoading: true,
        countsLoaded: false,
        error: ''
      };
    }

    case fromActions.CorporateDashboardActionTypes.LOAD_DASHBOARD_COUNTS_SUCCESS: {
      const payload = action instanceof fromActions.LoadDashboardCountsSuccess ? action.payload : undefined;
      return {
        ...state,
        dashboardCounts: payload?.counts || state.dashboardCounts,
        countsLoading: false,
        countsLoaded: true,
        error: ''
      };
    }

    case fromActions.CorporateDashboardActionTypes.LOAD_DASHBOARD_COUNTS_FAILURE: {
      const payload = action instanceof fromActions.LoadDashboardCountsFailure ? action.payload : undefined;
      return {
        ...state,
        countsLoading: false,
        countsLoaded: false,
        error: payload?.error || ''
      };
    }

    default:
      return state;
  }
}
